import { useTranslation } from 'react-i18next';
import type { ItemHealth } from '@/common/api/types/dashboard/health';
import type { ItemStatus } from '@/common/api/types/itemStatus';
import { DependencyIndicator } from '@/features/item-panel/components/tabs/dependencies/DependencyIndicator';
import { getSuccessorImpactState } from '@/features/item-panel/components/tabs/dependencies/lib/dependencyImpact';
import type { DependencyRow } from '@/features/item-panel/components/tabs/dependencies/lib/types';

export const DependencySuccessorCell = ({
  row,
  currentItemId,
  currentItemStatusId,
  healthByItemId,
  itemStatuses,
  anchorDate,
}: {
  row: DependencyRow;
  currentItemId: number;
  currentItemStatusId: number | null | undefined;
  healthByItemId: Map<number, ItemHealth | undefined>;
  itemStatuses: ItemStatus[];
  anchorDate: string | null | undefined;
}) => {
  const { t } = useTranslation();
  const state = getSuccessorImpactState({
    row,
    currentItemId,
    currentItemStatusId,
    healthByItemId,
    itemStatuses,
    anchorFinishDate: anchorDate,
  });

  if (state === 'error' || state === 'warning') {
    return (
      <DependencyIndicator
        state={state}
        label={
          state === 'error'
            ? t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.blockingBadge)
            : t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.atRiskBlockingBadge)
        }
        testId="successor-alert-badge"
      />
    );
  }

  if (state === 'neutral') {
    return (
      <DependencyIndicator
        state="neutral"
        label={t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.noDatesBadge)}
        testId="successor-no-dates-badge"
      />
    );
  }

  return <DependencyIndicator state="none" />;
};
